import { render, staticRenderFns } from "./OneCmsCarouselWithThumbnails.vue?vue&type=template&id=11408a05&scoped=true&"
import script from "./OneCmsCarouselWithThumbnails.vue?vue&type=script&lang=ts&"
export * from "./OneCmsCarouselWithThumbnails.vue?vue&type=script&lang=ts&"
import style0 from "./OneCmsCarouselWithThumbnails.vue?vue&type=style&index=0&id=11408a05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11408a05",
  null
  
)

export default component.exports